import { postAsync } from '../../utils/fetch';
import * as Types from './professions.types';

export const getProfessions = (search?: string) =>
    postAsync<Types.ProfessionInfo[]>('Course/GetProfessions', {
        search
    });
